export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/offers?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setOffers", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getOrderBumpOffer(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/sales/offers/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  getForOrderBump(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/sales/offers?${queryString}`)
        .then(response => {
          context.commit("setOrderBumpOffers", response.data.results);
          resolve(response);
        })
        .catch(reject);
    });
  },
  getOffer(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/sales/offers/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/offers", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/offers/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/sales/offers/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  duplicate(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/sales/offers/${params.id}/duplicate`, params)
        .then(resolve)
        .catch(reject);
    });
  }
};
